export function getManufacturer(name: string): string {
  return name || 'Unknown Manufacturer';
}

export default getManufacturer;
